module.exports = __webpack_public_path__ + "img/1F1E6-1F1F4.9a8ea684.svg";